/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { watchForNewVersion } from '@/lib/newVersion';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No #root element. index.html is missing its mount point.');
}

// A tab open across a deploy loads the new version rather than failing.
watchForNewVersion(window);

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
